import { AlertIcon } from '@/icons';
/**
 * Shared "the session-bootstrap query failed" screen for both root guards
 * (fix round 1, item 4). Before this, a failed `admin-session`/
 * `portal-session` call left the admin guard stuck on "Loading…" forever
 * (its decision only ever checked `adminSession === undefined`, which a
 * failed query never stops being true) and the business guard didn't check
 * `isError` at all — it fell through to rendering the full owner nav with
 * an empty membership list. Neither gives the visitor any way out besides
 * a hard reload.
 */
export function GuardErrorScreen({
  onRetry,
  onSignOut,
}: {
  onRetry: () => void;
  onSignOut: () => Promise<void>;
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-background p-lg">
      <div className="ng-reveal w-full max-w-[420px] rounded-card border border-border bg-surface p-xl text-center shadow-card">
        <span className="mx-auto grid h-12 w-12 place-items-center rounded-tile bg-tint-warning text-warning">
          <AlertIcon className="h-6 w-6" aria-hidden="true" />
        </span>
        <p className="mt-md text-h2 font-extrabold text-ink">Couldn&apos;t load your account</p>
        <p className="mt-xs text-body text-ink-2">Something went wrong. Try again, or sign out.</p>
        <div className="mt-lg flex items-center justify-center gap-md">
          <button
            type="button"
            onClick={onRetry}
            className="rounded-button bg-canyon px-lg py-sm font-sans text-body font-bold text-white"
          >
            Retry
          </button>
          <button type="button" onClick={() => void onSignOut()} className="text-body font-semibold text-ink-2 hover:underline">
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
